import React from 'react';

import { T } from '../../../../common/locale/translate';

import Table from './responsive-table';
import Offer from './offer-list-element';

const AdditionalInformations = props => {
  const renderHints = hints => {
    return (
      <div className="trip-hints">
        <h4>{T('additional_operator_description')}</h4>
        <pre>{hints}</pre>
      </div>
    );
  };

  const visibility = props => {
    return (props.hints !== null && props.hints.length > 0) ||
      props.flights.length > 0
      ? 'visible'
      : 'hidden';
  };

  const renderHeader = props => {
    return (
      props.additionalHeader && (
        <h4 className="additional-header">{props.additionalHeader}</h4>
      )
    );
  };

  const renderFlights = (flights, title, class_name) => {
    const headers = [
      { name: 'route', title: T('departure') },
      { name: 'iterchange_departure', title: T('departure_date') },
      { name: 'iterchange_arrival', title: T('arrival_date') },
      { name: 'flight_no', title: T('flight_number') },
      { name: 'airline_name', title: T('airline') }
    ];

    return (
      <div className="flights-interchanges">
        <h4>{title}</h4>
        <section className={`flight-interchanges all-types ${class_name}`}>
          <Table headers={headers}>
            {flights.map(function(flight, i) {
              return (
                <Offer
                  data={{ flights: [flight] }}
                  checkAvailability={false}
                  key={i}
                />
              );
            })}
          </Table>
        </section>
      </div>
    );
  };

  return (
    <div className={`additional-info ${visibility(props)}`}>
      {renderHeader(props)}
      {props.flights &&
        props.flights.length > 0 &&
        renderFlights(
          props.flights,
          `${T('flight_basic_info')}:`,
          'basic-flights'
        )}
      {props.flight_interchanges.length > 0 &&
        renderFlights(
          props.flight_interchanges,
          `${T('flight_interchanges_info')}:`,
          'without-dates'
        )}
      {props.hints !== null &&
        props.hints.length > 0 &&
        renderHints(props.hints)}
    </div>
  );
};

export default AdditionalInformations;



// WEBPACK FOOTER //
// ./app/javascript/common/components/additional_hints.jsx